<script setup lang="ts">
import useClient from "@/api/client";
import useCommand from "@/composables/useCommand";
import { ButtonNormal, ModalDelete } from "lorga-ui";
import { toRefs } from "vue";

const props = defineProps<{
  query: () => void;
  auftragId: string;
  begleitfahrtId: string;
  begleitfahrtBeschreibung: string;
}>();
const { auftragId, query, begleitfahrtId } = toRefs(props);

const client = useClient();

const { request } = client.post("/command/");
const { commandRequest, commandModalOpen } = useCommand(request, query.value);
</script>

<template>
  <ButtonNormal kind="delete" @click="commandModalOpen = true">E</ButtonNormal>
  <ModalDelete
    v-model="commandModalOpen"
    title="Begleitfahrt Entfernen"
    submit="Entfernen"
    :request="commandRequest"
    :data="{
      action: 'auftrag.begleitfahrt.entfernen',
      auftrag_id: auftragId,
      begleitfahrt_id: begleitfahrtId,
    }"
  >
    Willst du wirklich Begleitfahrt '{{ begleitfahrtBeschreibung }}' entfernen?
  </ModalDelete>
</template>
